"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const context_1 = require("../context");
const standardUtility_1 = require("../utility/standardUtility");
const react_native_1 = require("react-native");
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const PageBuilder = (props) => {
    const { state, setDataStoreInPath, appendWidgets, removeWidgets, } = (0, react_1.useContext)(context_1.Context);
    const standardUtilities = (0, react_1.useMemo)(() => (0, standardUtility_1.standardUtilitiesRaw)(state, setDataStoreInPath, appendWidgets, removeWidgets, props.routeCurrent, props.height || 0, props.width || 0), [state]);
    const [isLoading, setLoading] = react_1.default.useState(true);
    const processOnLoad = () => __awaiter(void 0, void 0, void 0, function* () {
        yield setLoading(true);
        const page = yield SharedPropsService_1.default.getPropsValue('routeMap')[props.routeCurrent];
        const onLoad = yield page.onLoad(standardUtilities, props.extraProps);
        console.info('onLoad', onLoad);
        yield setLoading(false);
    });
    (0, react_1.useEffect)(() => {
        processOnLoad();
    }, []);
    return isLoading ? (react_1.default.createElement(react_native_1.Text, null, "Loading...")) : (react_1.default.createElement(react_native_1.Text, null, "Hello World"));
};
exports.default = PageBuilder;
//# sourceMappingURL=page_builder.js.map